import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import { FlyoutHeader } from '../../utils/Flyout/64d9a6e73c9e4029974675d0c2b1dacdf7a73b9daa66e1961b492c2a5db7a276.cfe-internal.js';
import wrapEvent from '../../utils/wrapEvent/e6437ee06b490c01a1330c8f2f370768104fbf0b8f6557d196331cda5427061b.cfe-internal.js';

var _excluded = ["title", "children", "onMouseDown"];
var ComboboxHeader = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var title = _ref.title,
    children = _ref.children,
    onMouseDown = _ref.onMouseDown,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(FlyoutHeader, _extends({}, rest, {
    title: title,
    onMouseDown: wrapEvent(onMouseDown, function (e) {
      return e === null || e === void 0 ? void 0 : e.preventDefault();
    }),
    ref: ref
  }), children);
});

export { ComboboxHeader as default };
